<div *ngIf="!atLeastOneSignSize" class="horizontal-center">
  <span class="italics-text">
    Er wordt een offerte opgesteld voor dit bord
  </span>
</div>
<mat-card
  *ngIf="atLeastOneSignSize"
  class="top-card mat-elevation-z0 overflowHidden"
>
  <div class="strong">Prijzen</div>
  <div class="d-flex upper-space justify-content-between">
    <span>Aanmaakprijs</span>
    <span class="strong"
      >€ {{ productionPrice | asFormatDecimal: true:2 }}</span
    >
  </div>
  <div class="d-flex justify-content-between">
    <span>Plaatsingsprijs</span>
    <span class="strong">€ {{ placementPrice | asFormatDecimal: true:2 }}</span>
  </div>
  <div *ngIf="paintedPostsPrice > 0" class="d-flex justify-content-between">
    <span>Geschilderde constructieprijs</span>
    <span class="strong"
      >€ {{ paintedPostsPrice | asFormatDecimal: true:2 }}</span
    >
  </div>
  <div class="d-flex upper-space justify-content-between">
    <span>
      Subtotaal
      <mat-icon
        class="price-warning-icon"
        *ngIf="atLeastOneNoSignSize"
        matTooltip="Minstens één deelbord is geen standaardbord en is dus niet meegerekend in de getoonde prijs"
        >report_problem</mat-icon
      >
    </span>
    <span class="strong">€ {{ subtotal | asFormatDecimal: true:2 }}</span>
  </div>
</mat-card>
